var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAccordionButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.167368 3.99598C0.390524 3.77282 0.752333 3.77282 0.97549 3.99598L8 11.0205L15.0245 3.99598C15.2477 3.77282 15.6095 3.77282 15.8326 3.99598C16.0558 4.21914 16.0558 4.58095 15.8326 4.8041L8.80935 11.8274C8.70605 11.9354 8.58216 12.0216 8.44495 12.081C8.3045 12.1418 8.15306 12.1732 8 12.1732C7.84694 12.1732 7.6955 12.1418 7.55505 12.081C7.41784 12.0216 7.29395 11.9354 7.19065 11.8274L0.167368 4.8041C-0.0557892 4.58095 -0.0557892 4.21914 0.167368 3.99598Z",
    fill: "#133F26"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccordionButton);
export default __webpack_public_path__ + "static/media/accordion-button.d6d90775eca666ab7d28d98e410eeeeb.svg";
export { ForwardRef as ReactComponent };